import secureApi from "../services/secureApi";

export const dropdownTaxes = async () => {
  try {
    const response = await secureApi.get("/admin/tax/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching taxes:", error);
    return [];
  }
};

export const dropdownCategories = async () => {
  try {
    const response = await secureApi.get("/admin/category/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

export const dropdownCoupons = async () => {
  try {
    const response = await secureApi.get("/admin/coupon/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching coupons:", error);
    return [];
  }
};

export const dropdownSizes = async () => {
  try {
    const response = await secureApi.get("/admin/size/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching sizes:", error);
    return [];
  }
};

export const dropdownMaterials = async () => {
  try {
    const response = await secureApi.get("/admin/material/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching materials:", error);
    return [];
  }
};

export const dropdownFonts = async () => {
  try {
    const response = await secureApi.get("/admin/font/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching fonts:", error);
    return [];
  }
};

export const dropdownColors = async () => {
  try {
    const response = await secureApi.get("/admin/color/dropdown/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching colors:", error);
    return [];
  }
};

export const dropdownBlogs = async () => {
  try {
    const response = await secureApi.get(
      "/admin/blog-category/dropdown/list"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blog categories:", error);
    return [];
  }
};

export const dropdownProducts = async (search = "") => {
  try {
    const response = await secureApi.get(
      `/admin/products/dropdown?search=${encodeURIComponent(search)}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export const dropdownParentCategories = () => {
  return secureApi.get("/admin/category/parent/dropdown/list");
};

export const dropdownBlogsList = async () => {
  try {
    const response = await secureApi.get("/admin/blog/dropdown");
    return response?.data;
  } catch (error) {
    throw error;
  }
};